import React from 'react';
import ReactDOM from 'react-dom';

import { Modal, ContentModal } from 'sma.common/components/modals';
import Loader from 'sma.admin/components/loader';

import VideoLink from './videolink';
import getComponentWithTheme from '../../themeProvider';
import modals from '../../sma.common/components/modals';

const ajax = require('sma.common/ajax');

class VideoWindowModal extends Backbone.View {
	initialize(options) {
		this.froala = options.froala || null;
		this.$textField = options.$textField || null;
		this.edit_element = options.edit_element || null;
		this.fromModal = options.fromModal || false;
		this.award_id = options.award_id || window.sma_award_id || null;
		this.videoLink = options.videoLink || '';
		this.width = options.width || 700;
		this.height = options.height || 420;
		this.edit = this.edit_element !== null;

		this.onChange = this.onChange.bind(this);
		this.extractVideoInfo = this.extractVideoInfo.bind(this);
		this.createModal();
	}

	createModal() {
		const modalContent = '<div id="sma-js-video-window-container"><div class="mt-4 btn-loader"></div></div>';
		const title = this.edit ? gettext('Edit Vimeo or YouTube video link') : gettext('Add Vimeo or YouTube video link');
		const ok_label = this.edit ? gettext('Edit') : gettext('Add');

		this.modal = new ContentModal(modalContent, {
			destroyOnClose: true,
			size: 'md',
			title,
			fromModal: this.fromModal,
			buttons: [{
				label: gettext('Cancel'),
				cls: 'btn btn-link btn-loud',
				handler: (modal) => {
					modal.hide();
				},
			}, {
				label: ok_label,
				cls: 'btn btn-primary btn-loud',
				handler: (modal) => {
					if (this.submit()) {
						modal.hide();
					}
				},
			}],
		});

		this.setElement(this.modal.modalWindow);
		this.loadData();
	}

	submit() {
		const found = this.extractVideoInfo(this.videoLink);
		if (found === null) {
			new modals.Notify(
				_('Not supported'),
				`<p>${_('Supplied video is not supported. Only supporting Vimeo and YouTube.')}</p>`,
				_('Ok'),
				(() => {
					// Do nothing
				}),
			);
			return false;
		}
		const videoPiping = this.extractVideoInfo(this.videoLink);
		if (this.edit) {
			this.edit_element.parent().html(videoPiping);
			this.$textField.froalaEditor('events.trigger', 'contentChanged');
			return true;
		}
		this.froala.insertVideoPiping(videoPiping, this.$textField);
		return true;
	}

	onChange(value, field) {
		this[field] = value;
	}

	loadData() {
		this.modal.show();
		this.injectReact();
	}

	injectReact() {
		ReactDOM.render(
			getComponentWithTheme(
				<VideoLink
					insertVideo={this.onChange}
					width={this.width}
					height={this.height}
					videoLink={this.videoLink}
				/>,
				window.LOCALE.theme,
			),
			document.getElementById('sma-js-video-window-container'),
		);
	}

	extractVideoInfo(url) {
		const videoInfo = {
			id: null,
			platform: null,
		};
		const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
		const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/(?:video\/|channels\/[^\s\/]+\/|groups\/[^\s\/]+\/videos\/|)|player\.vimeo\.com\/video\/)(\d+)(?:[^\s]*)?/;

		const youtubeMatch = url.match(youtubeRegex);

		if (youtubeMatch) {
			videoInfo.id = youtubeMatch[1];
			videoInfo.platform = 'YouTube';
			return `<span class='form-video-element' style='display: none'>{{ ${videoInfo.platform}:${videoInfo.id}:${this.width}:${this.height} }}</span>`;
		}

		const vimeoMatch = url.match(vimeoRegex);
		if (vimeoMatch) {
			videoInfo.id = vimeoMatch[1];
			videoInfo.platform = 'Vimeo';
			return `<span class='form-video-element' style='display: none'>{{ ${videoInfo.platform}:${videoInfo.id}:${this.width}:${this.height} }}</span`;
		}
		return null;
	}
}

module.exports = VideoWindowModal;
